<!-- <dashboardnav> -->
<main class="reference_form-main">
  <div class="main_container">
    <form [formGroup]="reportRefForm">
    <div class="">
      <h3 class="form_name">Report Reference</h3>


        <div class="input">
          <label for="">Company Name</label>
          <input type="text" class="default_input reference-form" formControlName="CompanyName" />
        </div>
        <div class="input">
          <label for="">Logo</label>
          <input type="file" multiple (change)="onFilesAdded($event)" class="default_input reference-form" />
        </div>


      <div class="btn_holder">
        <button class="default_primary-button" *ngIf="selectedIndex === null"
         (click)="addNew(reportRefForm.value)">Add</button>
        <button class="default_primary-button" *ngIf="selectedIndex !== null"
            (click)="addNew(reportRefForm.value)">Update</button>
        <button class="default_secondary-btn ml-2" (click)="onClearForm()">Reset</button>

      </div>

    </div>
  </form>
    <div class="display_table">

      <div class="head" >
        <span class="item">S/N</span>
        <span class="item">Company Name</span>
        <span class="item">Logo</span>
        <span class="item">Action</span>

      </div>

    <div class="scroll">

    </div>
    <div class="body_content" >
      <div class="the_body"
      *ngFor="let reportRef of reportRefFormArray.get('ReportRefs')['controls']; index as i"
      (click)="onEdit(i, reportRef.value)" style="cursor: pointer;"
      matTooltip="Click to edit"
        aria-label="Button that displays a tooltip when focused or hovered over"
      >
        <span class="content">{{i + 1}}</span>
        <span class="content">{{reportRef.value.CompanyName}}</span>
        <span class="content"><img src="{{reportRef.value.Logo}}" alt="logo" width="50px" height="50px"></span>


      </div>
      </div>
      <div class="btn_holder">
        <button class="default_primary-button" (click)="onSubmit(reportRefFormArray.value)">
          <ng-container *ngIf="!loading">Submit</ng-container>
          <ng-container *ngIf="loading">Submitting...</ng-container>
          </button>
      </div>
    </div>
  </div>
</main>

<div class="box green_box"></div>
<div class="box pink_box"></div>
<!-- </dashboardnav> -->
